(function () {
  function applyMenuBadge() {
    const links = document.querySelectorAll("header a");

    links.forEach(link => {
      const text = link.textContent.trim();

      if (
        text === "MAABA STATUES" &&
        !link.classList.contains("menu-badge-applied")
      ) {
        link.classList.add("menu-badge-applied");

        const wrapper = document.createElement("span");
        wrapper.style.position = "relative";
        wrapper.style.display = "inline-block";
        wrapper.style.paddingTop = "16px";

        const badge = document.createElement("span");
        badge.innerText = "NEW";
        badge.style.position = "absolute";
        badge.style.top = "-14px";
        badge.style.left = "50%";
        badge.style.transform = "translateX(-50%)";
        badge.style.background = "#0ea5a2";
        badge.style.color = "#fff";
        badge.style.fontSize = "11px";
        badge.style.fontWeight = "700";
        badge.style.padding = "4px 10px";
        badge.style.borderRadius = "12px";
        badge.style.lineHeight = "1";
        badge.style.whiteSpace = "nowrap";
        badge.style.zIndex = "999";

        wrapper.appendChild(badge);
        wrapper.appendChild(document.createTextNode(text));

        link.textContent = "";
        link.appendChild(wrapper);
      }
    });
  }

  // Try multiple times in case header loads late
  let attempts = 0;
  const interval = setInterval(() => {
    applyMenuBadge();
    attempts++;
    if (attempts > 25) clearInterval(interval);
  }, 300);
})();
